module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_09.5b0a2ec5.jpg";